import img0 from '../assets/person0.jpeg'
import img5 from '../assets/person-f3.jpeg'
import { APP_LOGO, rootStore } from '../StApp'
import { SwipeCard } from './SwipeCard'

export const SwipeDateStack = () => {

    return (
        < >
            {
                rootStore.dateshipStore.swipeBuffer.map(item =>
                    <SwipeCard data={{ user: item, mainImgUrl: APP_LOGO, likeButton: false }}
                        upVote={() => rootStore.dateshipStore.commitLike(item.uid)}
                        downVote={() => rootStore.dateshipStore.commitDump(item.uid)}
                    />).reverse()
            }

        </>

    )
}